// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__3yb2F","fullScreen":"Loader_fullScreen__lA62w","loader":"Loader_loader__GrUtG","loaderDI":"Loader_loaderDI__LwvBo"};